module.exports = __webpack_public_path__ + "static/fulldomeComp1-b0d7d4a4268a8f68f3f6ad56480700ce.png";